const textosAutoCheckInitialState = {
    textosAutoCheckin : {
        data: [], 
        loading: false, 
        error: false 
    }
}

export default textosAutoCheckInitialState; 